// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'report.page.title.pension_contribution_report': 'Pension Contribution Report',
    'report.page.title.net_pay_listing': 'Net Pay Listing',
    'report.page.title.gross_pay_listing': 'Gross Pay Listing',
    'report.page.title.non_statutory_deductions_register': 'Non-Statutory Deductions Report',
    'report.page.title.statutory_deductions_register': 'Statutory Deductions Report',
    'report.page.title.payroll_summary_register': 'Payroll Summary Register',

    'report.label.pay_period': 'Pay Period',

    'report.label.employer': 'Employer',
    'report.label.employee': 'Employee',

    'report.label.employee_number': 'Employee No.',
    'report.label.employee_name': 'Name',
    'report.label.department': 'Department',
    'report.label.gross_pay': 'Gross Pay',

    'report.label.income_tax': 'Income Tax',
    'report.label.nis': 'NIS',
    'report.label.nht': 'NHT',
    'report.label.edt': 'Edu-Tax',
    'report.label.trn': 'TRN',
    'report.label.pension': 'Pension',
    'report.label.employee_pension': 'Employee Pension',
    'report.label.employer_pension': 'Employer Pension',
    'report.label.employer_heart': 'HEART',

    'report.label.other_deductions': 'Other Deductions',
    'report.label.non_stat_deductions': 'Non-Statutory Deductions',
    'report.label.net_pay': 'Net Pay',

    'report.label.total_gross_pay': 'Total Gross Pay',
    'report.label.total_income_tax': 'Total Income Tax',
    'report.label.total_nis': 'Total NIS',
    'report.label.total_nht': 'Total NHT',
    'report.label.total_edt': 'Total Edu-Tax',
    'report.label.total_pension': 'Total Pension',
    'report.label.total_net_pay': 'Total Net Pay',
    'report.label.total_other_deductions': 'Total Other Deductions',
    'report.label.total_employer_heart': 'HEART',
    'report.label.total_employee_pension': 'Total Employee Pension',
    'report.label.total_employer_pension': 'Total Employer Pension',

    'report.error.invalid_pay_period': 'There are no payroll batches available for the enter date range. Please enter a valid date range.',
};
